export default class ReCaptchaHandler {

	constructor() { }

	static init() {
		window.reCAPTCHA_key = document.querySelector('meta[name="g-reCAPTCHA-key"]').content;
		window.reCAPTCHA_checkbox_key = document.querySelector('meta[name="g-reCAPTCHA-checkbox-key"]').content;

		// Print script
		let script = document.createElement('script');
			script.src = 'https://www.google.com/recaptcha/enterprise.js?render=' + window.reCAPTCHA_key + '&checkbox=' + window.reCAPTCHA_checkbox_key;

		document.querySelector("head").appendChild(script);

		// hide reCAPTCHA badge with inline css + checkbox style
		let css = document.createElement('style');
			css.innerHTML =
				'.grecaptcha-badge { display: none !important }' +
				'#recaptcha-checkbox-dialog .modal-dialog { width: 329px }' +
				'#recaptcha-checkbox-dialog .modal-content { background: #f9f9f9 }' +
				'#recaptcha-checkbox-dialog .modal-body { padding: 15px 0 5px 15px }' +
				'#recaptcha-checkbox-dialog .recaptcha-widget > div > div { position: relative; overflow: hidden }' +
				'#recaptcha-checkbox-dialog .recaptcha-widget iframe { float: left; margin: -3px }' +
				'#recaptcha-checkbox-dialog .recaptcha-widget > div > div:after { content: ""; position: absolute; right: 0; top: 0; width: 10px; height: 100%; background: #f9f9f9 }';

		document.querySelector("head").appendChild(css);

		window.reCAPTCHA_Enterprise = ReCaptchaHandler.handler;
	}

	static handler(data) {
		let dialog = null;
		const options = Object.assign({
			action: "",

			url: "",
			method: 'POST',
			data: {},

			success: () => { },
			error: () => { }
		}, data);

		// google lib not loaded OR api key not received
		if (typeof grecaptcha === 'undefined' || !window.reCAPTCHA_key || !window.reCAPTCHA_checkbox_key) {
			return options.error('google-not-loaded');
		}

		// parameters not provided
		if (!options.action) {
			return options.error('action-needed');
		}

		// call api
		grecaptcha.enterprise.execute(reCAPTCHA_key, { action: options.action }).then(function (token) {
			// add token to data
			if (dataIsObject()) {
				options.data.recaptcha_token = token;
			}
			else {
				options.data.push({
					name: 'recaptcha_token',
					value: token
				});
			}

			// AJAX request
			doRequest();
		});

		function doRequest() {
			$.ajax({
				type: options.method,
				url: options.url,
				data: options.data
			}).always(function(response) {
				// handle reCAPTCHA challenge
				if ((typeof response.do_checkbox !== 'undefined' && response.do_checkbox) || (response.responseJSON && typeof response.responseJSON.do_checkbox !== 'undefined' && response.responseJSON.do_checkbox)) {
					return doCheckbox();
				}

				// close modal
				if (dialog) {
					dialog.addClass('callbacked').modal('hide');
				}

				// callback with response
				options.success(response);
			});
		}

		// CAPTCHA challenge
		function doCheckbox() {
			dialog = $('#recaptcha-checkbox-dialog');

			// add modal to DOM if not exists
			if (!dialog.length) {
				dialog = $('<div class="modal" id="recaptcha-checkbox-dialog" role="dialog" tabindex="-1" aria-labelledby="message-modal-title" aria-hidden="true">' +
					'	<div class="modal-dialog" role="document">' +
					'		<div class="modal-content">' +
					'			<div class="modal-body">' +
					'				<div id="recaptcha-checkbox" class="recaptcha-widget"></div>' +
					'			</div>' +
					'		</div>' +
					'	</div>' +
					'</div>');

				$('body').append(dialog);
			}

			// show modal
			dialog.removeClass('callbacked').modal();

			// bootstrap v5 modal
			if (window.BS_VERSION > 5) {
				dialog.removeClass('callbacked').modal('show');
			}

			// reCAPTCHA onload callback
			//	- for Google, otherwise it wont work
			window.renderReCAPTCHACheckbox = function () {
				// render widget
				grecaptcha.enterprise.render('recaptcha-checkbox', { 'sitekey': reCAPTCHA_checkbox_key });

				// wait for token
				window.reCAPTCHACheckboxCallback();
			};

			// wait for token callback
			window.reCAPTCHACheckboxCallback = function () {
				// clear old interval
				if (typeof window.reCAPTCHACheckboxInterval !== 'undefined') {
					clearInterval(window.reCAPTCHACheckboxInterval);
				}

				window.reCAPTCHACheckboxInterval = setInterval(function () {
					let token = grecaptcha.enterprise.getResponse();

					if (token) {
						// add token to data
						if (dataIsObject()) {
							options.data.recaptcha_token = token;
							options.data.recaptcha_checkbox = 1;
						}
						else {
							let index = options.data.findIndex(function (x) { return x.name == 'recaptcha_token'; });
							options.data[index].value = token;

							options.data.push({
								name: 'recaptcha_checkbox',
								value: 1
							});
						}

						// AJAX request
						doRequest();

						// clear interval
						clearInterval(window.reCAPTCHACheckboxInterval);
					}
				}, 100);
			};

			// remove old google script (change api JS to explicit)
			//	- switch site key script to checkbox key script
			let script = document.querySelector('script[src*="recaptcha/enterprise.js?checkbox"]');

			if (!script) {
				script = document.querySelector('script[src*="recaptcha/enterprise.js?onload=init&checkbox"]');
			}

			if (script) {
				let new_script = document.createElement('script');
				new_script.src = script.src.split('?')[0] + '?onload=renderReCAPTCHACheckbox&render=explicit';

				script.remove();
				document.querySelector('head').appendChild(new_script);
			}
			// reset current widget and runs callback again
			else {
				grecaptcha.enterprise.reset();

				window.reCAPTCHACheckboxCallback();
			}

			// dialog close event - restore
			dialog.one('hidden.bs.modal', function () {
				if (!dialog.hasClass('callbacked')) {
					options.error();
				}
			});
		};

		function dataIsObject() {
			return typeof options.data.length == 'undefined';
		};
	}

}